import React, { useContext } from "react";
import { AppContext } from "../AppContextProvider";
import close from "../assets/media/icons/cross-thin.svg";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
  MDBModalFooter,
} from "mdb-react-ui-kit";

export default function InfoModalCentral(props) {
  const context = useContext(AppContext);

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="central-info-modal">
        <MDBModalDialog scrollable centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <span className="title-text">Release Note</span>
              </MDBModalTitle>
              <MDBBtn className="button subtle large" type="button" onClick={props.hideModal}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.70703 8L13.8535 2.85352C14.0488 2.6582 14.0488 2.3418 13.8535 2.14648C13.6582 1.95117 13.3418 1.95117 13.1465 2.14648L8 7.29297L2.85352 2.14648C2.6582 1.95117 2.3418 1.95117 2.14648 2.14648C1.95117 2.3418 1.95117 2.6582 2.14648 2.85352L7.29297 8L2.14648 13.1465C1.95117 13.3418 1.95117 13.6582 2.14648 13.8535C2.24414 13.9512 2.37207 14 2.5 14C2.62793 14 2.75586 13.9512 2.85352 13.8535L8 8.70703L13.1465 13.8535C13.2441 13.9512 13.3721 14 13.5 14C13.6279 14 13.7559 13.9512 13.8535 13.8535C14.0488 13.6582 14.0488 13.3418 13.8535 13.1465L8.70703 8Z"
                    fill="var(--text-accent-maxi)"
                  />
                </svg>
              </MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="content">
                <h4 className="text-wrapper">Dear Dwinnies,</h4>
                <p className="div p18">
                  {
                    "this is Version 1.0 of Dwinity’s Digital Twin. Good things take time, but we will keep you updated with new features on a regular basis."
                  }
                </p>
                <br />
                {/*
                <h4 className="text-wrapper">{"Here’s what you can experience today:"}</h4>
                */}
                <ul className="decentralization-at">
                  {/*
                  <li className="d-flex align-items-center">
                    <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                      <span className="text-wrapper-2">Secure login via wallet integration</span>
                    </div>
                  </li>
                  */}
                  <li>
                    <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                      <h4 className="text-wrapper m-0">
                        Web3-compliant login via wallet integration
                        {/*
                        <span className="text-wrapper-2">
                          A first glimpse of visualized metadata and its connections to user-uploaded data.
                        </span>
                      */}
                      </h4>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                      <h4 className="text-wrapper m-0">
                        Upload your data dump <span className="text-wrapper-2">{"(only Amazon dumps for now)"}</span> to
                        a decentralized and completely secure environment
                      </h4>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                      <h4 className="text-wrapper m-0">
                        Interactive Bubble-Browser:{" "}
                        <span className="text-wrapper-2">
                          See how your meta data is connected to the Dwinity category tree.
                        </span>
                      </h4>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                      <h4 className="text-wrapper m-0">Browse your data and preview files</h4>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                      <h4 className="text-wrapper m-0">
                        Use the explorer view for a more classic approach and for tagging files manually
                        {/*
                        <span className="text-wrapper-2">for uploading, downloading, and deleting files</span>
                        */}
                      </h4>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                      <h4 className="text-wrapper m-0">
                        StorJ integration: All uploaded files are stored securely and decentrally.
                      </h4>
                    </div>
                  </li>
                </ul>
                <br />
                <p className="div p18">
                  <a
                    href="https://discord.com/invite/wthe2jh6"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "underline" }}
                  >
                    Join us on Discord for feedback and discussions.
                  </a>
                </p>
                <p className="div p18">
                  <a
                    href="https://www.amazon.de/gp/help/customer/display.html?nodeId=TP1zlemejtTn6pwYKS"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "underline" }}
                  >
                    Get your Amazon Data
                  </a>
                </p>
                {/*
                <p className="div p18">
                  {
                    "Note: The data shown is for demonstration purposes only and does not represent real user information unless you tested updating with you own data."
                  }
                </p>
                <p className="div p18">
                  {
                    "This demo data is intended to illustrate our approach to handling sensitive metadata in a Web3 environment."
                  }
                </p>
                */}
                <br />
                <h4 className="text-wrapper">Looking ahead:</h4>
                <p className="div p18">
                  {
                    "This technology is poised to revolutionize data processing, metadata preparation, and profitable sharing. Join us as a Beta Tester to help shape the future and earn $DWIN! If you have any questions about the process, don’t hesitate to "
                  }
                  <a
                    href="https://dwinity.com/contact/"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "underline" }}
                  >
                    contact
                  </a>{" "}
                  us.
                </p>
                <p className="div p18">
                  {"Thank you for your interest and contribution to our journey. We look forward to hearing from you!"}
                </p>

                <span className="div p18">{"Best regards — The Dwinity Team"}</span>
                {/*
                <p className="div p18">{"The Dwinity Team"}</p>
                <br />
                
                <p className="div p18">
                  P.S. Have you already seen our introduction video?{" "}
                  <a href="https://www.youtube.com/watch?v=YU-rR_j4iGE" target="_blank" rel="noreferrer">
                    {" "}
                    Watch it here.
                  </a>
                </p>
                */}
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <button type="button" className="button accent medium" onClick={props.hideModal}>
                <span className="text">Continue</span>
              </button>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
